<template>
  <div class="card card-custom card-stretch mb-5">
    <div class="card-header align-items-start border-0 mt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label fw-bolder text-dark fs-3">
          Размер моей доли в компании
        </span>
      </h3>
<!--      <div class="card-toolbar">-->
<!--        <a href="#" title="В деньгах" class="nav-link btn btn-sm btn-active-light btn-light py-2 px-4 fw-bolder me-2">-->
<!--          ₽-->
<!--        </a>-->
<!--        <a href="#" title="В процентах"-->
<!--           class="nav-link btn btn-sm btn-active-success btn-light py-2 px-4 fw-bolder active">-->
<!--          %-->
<!--        </a>-->
<!--      </div>-->
    </div>
    <div v-if="pretend || current || bought" class="card-body d-flex flex-column justify-content-around">
      <div
        class="d-flex flex-center position-relative bgi-no-repeat bgi-size-contain bgi-position-x-center bgi-position-y-center"
      >
        <div class="fw-bolder fs-1 text-gray-800 position-absolute">
          <Percent :value="current + pretend"/>
        </div>
        <apexchart
          type="donut"
          :options="options"
          :series="series"
          height="200"
        ></apexchart>
      </div>

        <div class="d-flex flex-row justify-content-between">
          <div v-if="current" class="pr-3">
            <span class="fw-bolder text-gray-800">
              Моя доля<br/>
              <Percent :value="current"/>
            </span>
            <span class="w-25px h-5px d-block rounded mt-1" v-bind:style="{backgroundColor: '#22d48a'}"></span>
          </div>

          <div v-if="pretend">
            <span class="fw-bolder text-gray-800">
              Претендую<br/>
              <Percent :value="pretend"/>
            </span>
            <span class="w-25px h-5px d-block rounded mt-1" v-bind:style="{backgroundColor: '#fec703'}"></span>
          </div>

          <div v-if="bought">
            <span class="fw-bolder text-gray-800">
              Выкуплено<br/>
              <Percent :value="bought"/>
            </span>
            <span class="w-25px h-5px d-block rounded mt-1" v-bind:style="{backgroundColor: 'rgba(24, 28, 50, 0.25)'}"></span>
          </div>
        </div>
      </div>
    <div v-else class="card-body pt-12">
      <div
        class="d-flex flex-center position-relative bgi-no-repeat bgi-size-contain bgi-position-x-center bgi-position-y-center h-175px"
      >
        <div class="text-center">
          <div>У тебя еще нет активного опциона</div>
          <div v-if="bought" class="mt-3 fw-bolder text-gray-800">
            <Percent :value="bought"/> выкуплено
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.pr-3 {
  margin-right: 0.75rem;
}
</style>

<script>
import {percent} from "../helpers/formatter";
import Percent from "./components/Percent";

export default {
  components: {Percent},
  props: {
    my: Array,
    statistic: Array,
  },

  data() {
    let current = 0
    let pretend = 0
    let bought = 0

    this.my.forEach(v => {
      if (v.status === 'planned') {
        pretend += v.percent
        return
      }

      if (v.status === 'bought') {
        bought += v.percent
        return
      }

      if (v.status === 'distributed') {
        current += v.percent
      }
    })

    const options = {
      chart: {
        type: "donut",
        fontFamily: "inherit"
      },
      plotOptions: {
        pie: {
          // customScale: 0.84,
          expandOnClick: false,
          donut: {
            size: "75%"
          }
        }
      },
      labels: ["Моя доля", "Претендую в этом году", "Выкуплено"],
      colors: ["#22d48a", "#fec703", "rgba(24, 28, 50, 0.25)"],
      legend: {
        show: false
      },
      dataLabels: {
        enabled: false,
      },
      tooltip: {
        y: {
          formatter: (v) => {
            return percent(v)
          },
          title: {
            formatter: (seriesName) => seriesName,
          },
        },
      },
      animation: {
        animateScale: true,
        animateRotate: true
      }
    };

    return {
      options,
      series: [current, pretend, bought],
      current,
      pretend,
      bought,
    };
  },

  methods: {
    percent,
  }
}
</script>
